<template>
  <div class="layout-options-setting-dialog">
    <template v-if="curNav !== 0">
      <div class="navBackBox" @click="changeNav(0, false)">
        <i class="navBackIcon icon-portal-arrows-left"></i>
        <span class="navBackTitle">{{ navName }}</span>
      </div>
    </template>
    <anchorBtnSetting :configData="anchorBtnConfig" v-if="curNav === 1 && anchorSettingStatus === 'sub'"></anchorBtnSetting>
    <anchorTipsSetting :configData="anchorTipsConfig"  v-if="curNav === 4 && anchorSettingStatus === 'sub'"></anchorTipsSetting>
    <anchorExpandSetting :configData="anchorExpandConfig"  v-if="curNav === 3 && anchorSettingStatus === 'sub'"></anchorExpandSetting>
    <anchorBackSetting :configData="anchorBackConfig"  v-if="curNav === 2 && anchorSettingStatus === 'sub'"></anchorBackSetting>
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%" v-if="bayWindow">
        <el-collapse-item title="排列" name="3" v-if="showRowColLayout">
          <rowColLayoutSetting :options="firstRowLayout.options" :ids="ids" @update="handleRowSet"/>
        </el-collapse-item>
        <el-collapse-item title="尺寸" name="1">
          <div class="verticallyCenter">
            <slider-and-input
              class="mb16"
              inputWidth="small"
              inputHeight="small"
              :value.sync="bayWidth"
              title="宽"
              titlePosition="allInOneLine"
              :sliderMax="bayWindowWidthMax"
              suffix="px"
            />
          </div>
          <div class="verticallyCenter" v-if="bayWindow">
            <slider-and-input
              inputWidth="small"
              inputHeight="small"
              :value.sync="bayHeight"
              title="高"
              titlePosition="allInOneLine"
              :sliderMax="bayWindowHeightMax"
              suffix="px"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item title="位置" name="2">
          <div class="lineHeight32">
            <span style="margin-right: 15px">起始设置</span>
            <el-select v-model="bayStartPosition" style="width: 156px">
              <el-option label="从左上角开始" value="topLeft"></el-option>
              <el-option label="从右上角开始" value="topRight"></el-option>
              <el-option label="从左下角开始" value="bottomLeft"></el-option>
              <el-option label="从右下角开始" value="bottomRight"></el-option>
            </el-select>
          </div>
          <div class="lineHeight32 margin-top-16">
            <span style="margin-right: 15px">移动速度</span>
            <div class="move-speed-btn">
              <span class="btn-active" :style="getTranslate"></span>
              <span
                v-for="(option, index) in moveSpeedList"
                :key="index"
                class="fs13"
                :class="bayMoveSpeed == option.label ? 'select pd2' : 'pd2'"
                @click="changeMoveSpeed(option.label)"
                >{{ option.title }}</span
              >
            </div>
          </div>
          <div class="lineHeight32 margin-top-16">
            <cx-check-box :value.sync="bayManualClose">允许手动关闭</cx-check-box>
          </div>
        </el-collapse-item>
        <el-collapse-item title="更多" name="3">
          <div class="content-item verticallyBetweenCenter">
            <span class="verticallyCenter">布局模式<i class="tips-btn icon-portal-info2" @click="explainAutoDialog = true"></i></span>
            <el-select v-model="autoLayoutType" style="width: 120px;">
              <el-option v-for="(item, index) in layoutTypeList" :key="index" :label="item.label" :value="item.value">
              <span style="font-size: 13px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </div>
        </el-collapse-item>
      </el-collapse>
      <el-collapse v-model="activeNames" style="width: 100%" v-else-if="smartServices">
        <el-collapse-item title="选择机器人" name="1">
          <div>
            <div class="verticallyCenter">
              <span class="verticallyCenter mr8">机器人<i class="tips-btn icon-portal-info2" ></i></span>
              <el-select v-model="robotId">
                <el-option
                  v-for="(item, index) in robotNameList"
                  :key="index"
                  :selected="robotId == item.robotId"
                  :value="item.robotId"
                  :label="item.robotNickname"
                >{{ item.robotNickname }}
                </el-option>
              </el-select>
            </div>
            <div class="mt12 verticallyCenter robot-box">
              <div class="img-box"><img :src="robotCover" alt=""></div>
              <div class="text-box">
                <p class="text-title">{{ robotItem.robotNickname }}</p>
                <p class="text-id overflowHid3">id：{{ robotId }}</p>
              </div>
            </div>
          </div>

        </el-collapse-item>
        <el-collapse-item title="接入方式" name="2">
          <div class="verticallyCenter">
            <el-radio-group v-model="robotWays">
              <el-radio
                v-for="(item, index) in robotWaysList"
                :key="index"
                :label="item.label"
                >{{ item.value }}</el-radio
              >
            </el-radio-group>
          </div>
        </el-collapse-item>
      </el-collapse>
      <el-collapse v-model="activeNames" style="width: 100%" v-else-if="anchorSettingStatus !== 'sub'">
        <el-collapse-item
          v-if="
            (inDocument === 'header' ||
              inDocument === 'relativeHeader' ||
              inDocument === 'footer' ||
              inDocument === 'anchor') &&
            (request_prefix === 'stage' || (request_prefix === 'appStage' && isNotHomePage))
          "
          :title="
            inDocument === 'header' || inDocument === 'relativeHeader'
              ? '头部样式'
              : inDocument === 'footer'
              ? '底部样式'
              : inDocument === 'anchor'
              ? '锚点样式'
              : ''
          "
          name="3"
          class="padding_0"
        >
          <template slot="title">
            {{
              inDocument === "header" || inDocument === "relativeHeader"
                ? "头部样式"
                : inDocument === "footer"
                ? "底部样式"
                : inDocument === "anchor"
                ? "锚点样式"
                : ""
            }}
            <span class="stop-blank" @click.stop></span>
            <div class="more-btn" @click.stop="moreClick()" v-if="showRefSetting && request_prefix === 'stage'">
              更多<i class="icon-portal-arrows-right"></i>
            </div>
          </template>
          <div class="types-options-style">
            <div class="setting-item clearFloat mb12" v-if="showRefSetting && request_prefix === 'stage'">
              <el-popover
                ref="previewPopover"
                popper-class="previewPopover"
                placement="left"
                title=""
                trigger="hover"
                :visible-arrow="false"
                :disabled="disablePreview"
              >
                <img style="width: 100%; height: 100%" :src="previewSrc" />
                <div slot="reference" class="content">
                  <swiper :options="swiperOptions" ref="mySwiper">
                    <swiper-slide v-for="idx in swiperLen" :key="idx">
                      <ul class="types-list">
                        <li
                          class="types-list-li"
                          v-for="(item, index) in styleDatas.slice(
                            4 * (idx - 1),
                            4 * idx > styleDatas.length ? styleDatas.length : 4 * idx
                          )"
                          @click="selectStyle(item, index)"
                          :class="activePublicId === item.publicId ? 'active' : ''"
                          :key="index"
                        >
                          <div class="img-box" @mouseenter="setMouseEnter" @mouseout="setMouseOut">
                            <img :src="item.cover ? item.cover : defaultImg" alt="" />
                            <span class="delete-icon" @mousedown.stop @click.stop="delComponent(item)"
                              ><i class="icon icon-portal-delete"></i
                            ></span>
                            <i class="icon-checked" v-if="request_prefix !== 'bigScreen'"></i>
                          </div>
                          <p class="overflowHid1">{{ item.name || item.title }}</p>
                        </li>
                      </ul>
                    </swiper-slide>
                  </swiper>
                  <div class="swiper-button swiper-button-prev" v-if="styleDatas.length > 6" @click="swiperPrev"></div>
                  <div class="swiper-button swiper-button-next" v-if="styleDatas.length > 6" @click="swiperNext"></div>
                </div>
              </el-popover>
            </div>
            <div
              class="mb12"
              v-if="
                (pageType === 'listPage' || pageType === 'detailPage' || pageType === 'equalPage') &&
                (inDocument === 'header' || inDocument === 'footer')
              "
            >
              <el-checkbox v-model="isRefHome" v-if="!(inDocument === 'header' && isSubHeadPage)">
                {{ inDocument === "header" ? refHeadTitle : inDocument === "footer" ? "同步首页底部样式" : "" }}
              </el-checkbox>
              <!-- <el-checkbox v-if="isRefHome && inDocument === 'header'" v-model="isRefNav"
                >同步首页头部导航
              </el-checkbox> -->
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          title="排列"
          name="4"
          v-if="request_prefix !== 'bigScreen' && inDocument !== 'anchor' && showRefSetting && !isWaterFlow"
        >
          <!-- 一行时才能开启 -->
          <!--          一帆需求, 屏蔽通栏自动布局，保留根布局的自动布局-->
          <!--          <div class="content-item mb12" style="height: 20px;line-height: 20px;">-->
          <!--            <el-checkbox v-model="showRowColLayout" :disabled="rowLen !== 1">自动布局</el-checkbox>-->
          <!--            <i class="tips-btn icon-portal-info2" @click="explainAutoDialog = true"></i>-->
          <!--          </div>-->
          <!--          <div v-if="showRowColLayout">-->
          <!--            <rowColLayoutSetting :options="firstRowLayout.options" :ids="ids" @update="handleRowSet"/>-->
          <!--          </div>-->
          <div class="verticallyTop">
            <span class="fs14 mr16 mt4">行数</span>
            <div class="row-set">
              <div class="verticallyCenter el-input">
                <single-input
                  class="mr8"
                  style="width: 104px; height: 32px; flex: 1"
                  :value.sync="rowLen"
                  :noInputSuffixs="true"
                  :min="1"
                  :max="10"
                  :noInputHandle="true"
                />
                <div class="btn-wrapper">
                  <span
                    :class="rowLen === 1 ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
                    @click="changeRowLen(0)"
                  ></span>
                  <span
                    :class="rowLen === 10 ? 'disabled num-btn icon-portal-plus' : 'num-btn icon-portal-plus'"
                    class="num-btn icon-portal-plus"
                    @click="changeRowLen(1)"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <template v-if="showRefSetting">
          <el-collapse-item
            title="内容区宽度"
            name="5"
            v-if="
              (inDocument !== 'anchor') &&
              ((request_prefix === 'stage' && !bayWindow) ||
              (request_prefix === 'appStage' && positionType !== 'relative'))
            "
          >
            <el-radio-group v-model="pageLayoutWidthType">
              <el-radio label="1" v-if="request_prefix === 'stage' && !enableLeftNav"
                ><span class="custom-label">与页面宽度保持一致</span></el-radio
              >
              <el-radio label="2" v-if="request_prefix === 'stage' && !enableLeftNav"
                ><span class="custom-label">宽度充满通栏</span
                ><i class="tips-btn icon-portal-info2" @click.stop.prevent="explainDialogClick(1)"></i>
              </el-radio>
              <el-radio label="3">
                <span class="custom-label">自定义宽度</span>
              </el-radio>
            </el-radio-group>
            <single-input
              v-show="pageLayoutWidthType === '3'"
              class="ml8 input-size custom-width-inp"
              style="display: inline-block; width: 108px; height: 32px; margin-top: -54px; margin-left: 100px"
              placeholder="-"
              :value.sync="customWidth"
              :valueType.sync="customWidthType"
              :showValueType="true"
              :min="1"
            />
          </el-collapse-item>
          <el-collapse-item title="锚点按钮" name="1" v-if="inDocument === 'anchor' && isNewAnchor && anchorSettingStatus !== 'sub'">
            <div class="navBox mb8" @click="changeNav(1, true, '锚点按钮')">
              <span class="navTitle">锚点按钮</span>
              <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
            </div>
            <div class="navBox mb8" @click="changeNav(2, true, '返回顶部按钮')">
              <span class="navTitle">返回顶部按钮</span>
              <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
            </div>
            <div class="navBox mb8" @click="changeNav(3, true, '收起展开按钮')">
              <span class="navTitle">收起展开按钮</span>
              <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
            </div>
            <!-- 功能未做暂时屏蔽 -->
            <div class="navBox" @click="changeNav(4, true, '提示文字')">
              <span class="navTitle">提示文字</span>
              <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
            </div>
          </el-collapse-item>
          <!-- <anchorBtnSetting :configData="anchorBtnConfig"></anchorBtnSetting>  -->
          <!-- <anchorTipsSetting :configData="anchorTipsConfig"></anchorTipsSetting>  -->
          <!-- <anchorExpandSetting :configData="anchorExpandConfig"></anchorExpandSetting>
          <anchorBackSetting :configData="anchorBackConfig"></anchorBackSetting> -->
          <!-- <el-collapse-item title="尺寸" name="99" v-if="inDocument === 'anchor'">
            <div class="verticallyCenter">
              <slider-and-input
                class="mb16"
                inputWidth="small"
                inputHeight="small"
                :value.sync="bayWidth"
                title="宽"
                titlePosition="allInOneLine"
                :sliderMax="bayWindowWidthMax"
                suffix="px"
              />
            </div>
            <div class="verticallyCenter">
              <slider-and-input
                inputWidth="small"
                inputHeight="small"
                :value.sync="bayHeight"
                title="高"
                titlePosition="allInOneLine"
                :sliderMax="bayWindowHeightMax"
                suffix="px"
              />
            </div>
          </el-collapse-item> -->
          <el-collapse-item title="滚轴" name="4" v-if="inDocument === 'anchor' && isRollerAnchor">
            <slider-and-input :value.sync="lineBorderWidth" title="粗细" :sliderMax="200" suffix="px" />
          </el-collapse-item>
          <el-collapse-item title="背景" name="6" v-if="anchorSettingStatus !== 'sub'">
            <cx-background infoTips="支持上传图片和视频" :background.sync="background" :showVideo="true" imgType="10" />
          </el-collapse-item>
          <el-collapse-item title="边框" name="9">
            <div>
              <div class="content-item verticallyCenter mb8">
                <el-checkbox v-model="showBorder">显示边框</el-checkbox>
              </div>
              <cx-border
                v-if="showBorder"
                :borderWidth.sync="borderWidth"
                :borderStyle.sync="borderStyle"
                :borderColor.sync="borderColor"
                :borderIsThemeColor.sync="borderIsThemeColor"
              />
            </div>
            <div class="content-item mt16">
              <border-radius
                :borderTypeFlag.sync="borderTypeFlag"
                :borderRadius.sync="borderRadius"
                :borderTopLeftRadius.sync="borderTopLeftRadius"
                :borderTopRightRadius.sync="borderTopRightRadius"
                :borderBottomRightRadius.sync="borderBottomRightRadius"
                :borderBottomLeftRadius.sync="borderBottomLeftRadius"
              />
            </div>
          </el-collapse-item>
          <el-collapse-item title="边距" name="7"  v-if="anchorSettingStatus !== 'sub'">
            <cx-padding
              :paddingTypeFlag.sync="paddingTypeFlag"
              :padding.sync="padding"
              :paddingTop.sync="paddingTop"
              :paddingRight.sync="paddingRight"
              :paddingBottom.sync="paddingBottom"
              :paddingLeft.sync="paddingLeft"
              :sliderMax="1000"
            />
          </el-collapse-item>
          <el-collapse-item title="位置" v-if="request_prefix !== 'bigScreen' && anchorSettingStatus !== 'sub' && !enableLeftNav" name="8">
            <!-- <el-checkbox v-if="isAdmin && positionType === 'fixed'" v-model="enableTeleport" class="mb10"
              >固定在当前屏幕</el-checkbox
            > -->
            <positionSet
              :ids="ids"
              :left.sync="pLeft"
              :right.sync="pRight"
              :top.sync="pTop"
              :bottom.sync="pBottom"
              :translate.sync="translate"
              :positionType.sync="positionType"
              :positionSiteType.sync="positionSiteType"
              :pxOffset.sync="pxOffset"
              :inDocument.sync="inDocument"
              :zIndex.sync = "zIndex"
            ></positionSet>
          </el-collapse-item>
          <!-- 注释：后面没用就删除 -->
          <!-- <el-collapse-item v-if="inDocument === 'header' || inDocument === 'relativeHeader'" title="自适应" name="9">
            <div
              v-for="(val, k) in primaryHeadContainerRect"
              :key="k"
              :data-k="11 + k"
              :class="k === 'nav' ? '' : 'mt8'"
            >
              <cx-select
                clearable
                :popper-class="'containerSetting' + 'headComponentMap' + 'k'"
                :title="primaryHeadContainerRectNames[k]"
                :selectOptions="filterRect(rectInContainerOptions, k)"
                :value="val"
                @change="changeContainerPrimaryRect('headComponentMap', k, $event)"
                @visible-change="selectVisibleChange('containerSetting' + 'headComponentMap' + 'k', $event)"
              />
            </div>
          </el-collapse-item> -->
          <!--          一帆需求，不要这个开关了-->
          <!--          <el-collapse-item title="高级设置" v-if="request_prefix !== 'bigScreen' && isAdmin" name="10">-->
          <!--            &lt;!&ndash; 产品要求开启自动布局默认开启尺寸自适应 &ndash;&gt;-->
          <!--            &lt;!&ndash; <cx-check-box :value.sync="childSizeAuto">开启子元素尺寸自适应</cx-check-box> &ndash;&gt;-->
          <!--            <autoLayoutSetting :options="layoutOptions" :ids="ids" @update="handleSet" />-->
          <!--          </el-collapse-item>-->
          <el-collapse-item title="更多" name="11" v-if="anchorSettingStatus !== 'sub'">
            <div class="setting-item">
              <div class="content">
                <div class="content-item mb12">
                  <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
                </div>
                <div class="content-item mb12" v-if="childSizeAuto && inDocument === 'anchor'">
                  <slider-and-input :value.sync="marginBottom" title="间距" :sliderMax="100" suffix="px" />
                </div>
                <div class="content-item mt12">
                  <div class="checkbox_colorPicker_container">
                    <span>阴影</span>
                    <span
                      v-show="borderShadowChecked"
                      class="icon-portal-plus theme-color right-icon"
                      @click="addBoxshadow"
                    ></span>
                  </div>
                  <box-shadow
                    v-show="borderShadowChecked"
                    :boxShadowH.sync="boxShadowH"
                    :boxShadowV.sync="boxShadowV"
                    :boxShadowBlur.sync="boxShadowBlur"
                    :boxShadowSpread.sync="boxShadowSpread"
                    :boxShadowColor.sync="boxShadowColor"
                  ></box-shadow>
                </div>
                <div class="content-item mb12">
                  <public-style :options="layoutOptions" :ids="ids"></public-style>
                </div>
              </div>
            </div>
            <div>
              <el-checkbox
                v-model="enableLayoutFullScroll"
                v-if="
                  request_prefix === 'stage' &&
                  !globalEnableFullScroll &&
                  (positionType === 'relative' || !positionType) &&
                  ['header', 'footer', 'relativeHeader'].indexOf(inDocument) == -1
                "
              >
                整屏切换
                <i class="tips-btn icon-portal-info2" @click.stop.prevent="explainDialogClick(2)"></i>
              </el-checkbox>
              <template v-if="showScrollModelSetting">
                <div>切换模式:</div>
                <el-radio-group v-model="scrollModel" v-if="showScrollModelSetting">
                  <el-radio label="smooth">平滑切换</el-radio>
                  <el-radio label="cover">覆盖切换</el-radio>
                </el-radio-group>
                <div>溢出设置:</div>
                <el-select v-model="layoutOverflowControl">
                  <el-option value="hidden" label="隐藏"></el-option>
                  <el-option value="scroll" label="滚动"></el-option>
                  <el-option value="autoScale" label="自适应缩放"></el-option>
                </el-select>
              </template>
            </div>
            <div>
<!--              <el-checkbox v-if="request_prefix==='stage'" v-model="enableLeftNav">-->
<!--                开启侧边栏功能-->
<!--              </el-checkbox>-->
<!--              <el-checkbox v-if="request_prefix==='stage'"  v-model="isHeaderOther">-->
<!--                跟随头部通栏-->
<!--              </el-checkbox>-->
            </div>
          </el-collapse-item>
        </template>
        <el-collapse-item v-show="$store.state.states.showPluginSetting" title="插件" name="12">
          <div class="setting-item">
            <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips" v-for="(item, index) in explainTextList" :key="index">
        <span>{{ item.explainTitle }}</span
        >{{ item.explainTips }}
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainAutoDialog" custom-class="explainDialog">
      <div class="auto-layout-body">
      <p class="fs14 tips">
        <span>排列模式：</span>
      </p>
      <ul>
        <li>开启排列模式后，布局内部元素会按照一定方向排列，配合行布局组件可以实现均匀的排列效果</li>
      </ul>
      <p class="fs14 tips">
        <span>功能说明：</span>
      </p>
      <p>
        通常情况下，一个网页的元素是遵从一定的顺序进行排列，例如2张图片横向排列，第3张以及后续图片都希望自动往左侧填充，超过宽度则自动换行，不仅可以减少整理页面的时间还可以实现更灵活的自适应效果。可以理解「自动布局」是为了简化原生页面使用Flex属性，并且达到类似的效果，你可以做到：
      </p>
      <ul>
        <li>让按钮或卡片随文本增减而自动调整尺寸</li>
        <li>将列表快速重新排序</li>
        <li>实现更多更复杂元素的全自动排布</li>
      </ul>
      </div>
    </el-dialog>
    <pageLayout-style
      v-if="showPageLayoutStyle"
      :curPageLayoutIndex="curPageLayoutIndex"
      :pageLayoutList="pageLayoutList"
      :id="ids.container_id"
      :showDialog.sync="showPageLayoutStyle"
      :twoTypeId="typeId"
    >
    </pageLayout-style>
  </div>
</template>

<script>
import { getWebsiteSubHeadPageId } from "@/utils/refHead"
import { handleChildAppid } from "@/utils/reCreatAppid"
import widthAndSizeAndZindex from "../../../components/toolbar-option-components/publicSetting/widthAndSizeAndZindex.vue"
import { primaryBigScreenPageLayoutGenerator as primarybigScreenPageLayoutGenerator } from "store/modules/bigScreen/state"
import { primaryStagePageLayoutGenerator as primarystagePageLayoutGenerator } from "store/modules/stage/state"
import { primaryappStagePageLayoutGenerator as primaryappStagePageLayoutGenerator } from "store/modules/appStage/state"
import { getAllRectInNewLayout, decrypt, findRectPath, smartMathMax } from "utils"
import { deepCloneAndFreeze, withMethodsHistoryCombine } from "utils/revork"
import { GetRequest } from "utils/initUrlQueryData"
import { componentNames } from "dependencies/base"
import positionSet from "./position-set.vue"
import autoLayoutSetting from "toolbarComponents/colsComponent/setting/autoLayoutSetting.vue"
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper"
import instance from "@/interceptor"
import { data_dictionary_map } from "root/static/dataDictionary.js"
import { reverseBuildModel } from "utils/reverseBuildModel.js"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import CxPadding from "../../../modules/components/cxPadding"
import pageLayoutStyle from "../../../components/toolbar-option-components/styles/pageLayout-style"
import { addSubPageMapping } from "utils/updateData/publicDataUtils/subPageUpdateData.js"
import rowColLayoutSetting from "../../autoLayout/toolbars/setting/rowColLayoutSetting.vue"
import anchorBackSetting from '@/materials/pageLayout/toolbars/anchorConfigs/anchorBack/index.vue'
import anchorBtnSetting from '@/materials/pageLayout/toolbars/anchorConfigs/anchorBtn/index.vue'
import anchorTipsSetting from '@/materials/pageLayout/toolbars/anchorConfigs/anchorTips/index.vue'
import anchorExpandSetting from '@/materials/pageLayout/toolbars/anchorConfigs/anchorExpand/index.vue'
import { v1 } from 'uuid'
import publicStyle from "publicSetting/publicStyle.vue"

const uuid = { v1 }
const basePrimaryHeadContainerRect = {
  nav: "",
  logo: "",
  login: ""
}
const primaryHeadContainerRectNames = {
  nav: "导航",
  logo: "logo",
  login: "登录"
}
const mockData = {
  primarybigScreenPageLayoutGenerator,
  primarystagePageLayoutGenerator,
  primaryappStagePageLayoutGenerator
}

export default withMethodsHistoryCombine({
  name: "pageLayout-options-setting",
  props: {
    mouseType: {
      default: "default",
      type: String
    },
    options: Object
  },
  data() {
    return {
      curNav: 0,
      activeNames: ["1", "2", "3", "4", "5", "6"],
      hoverOpt: [],
      this1: this,
      // primaryHeadContainerRectNames,
      activeType: 1,
      sliderMax: 360,
      paddingMax: 200,
      borderShadowChecked: true,
      positionList: [
        {
          value: "relative",
          title: "无定位"
        },
        {
          value: "absolute",
          title: "绝对定位"
        },
        {
          value: "fixed",
          title: "固定定位"
        }
      ],
      sizeTypes: [
        {
          label: "px",
          value: "px"
        },
        {
          label: "%",
          value: "%"
        }
      ],
      defaultImg: require("../../../assets/images/default_image_home.png"),
      typeId: null,
      styleDatas: [],
      swiperLen: 0,
      swiperOptions: {
        loop: false,
        speed: 500,
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button.swiper-button-next",
          prevEl: ".swiper-button.swiper-button-prev"
        }
      },
      moveSpeedList: [
        {
          label: "high",
          title: "快"
        },
        {
          label: "medium",
          title: "中"
        },
        {
          label: "slow",
          title: "慢"
        }
      ],
      explainDialog: false,
      explainAutoDialog: false,
      testColor: "",
      explainTextList: [],
      explainImgSrc: "",
      explainVideoSrc: "",
      curPageLayoutIndex: 0,
      showPageLayoutStyle: false,
      headerNavAppId: undefined,
      newLayout: {},
      hasHeadComponentNav: false, //用于切换头部样式的时候 判断新的头部样式中是否有内置的导航组件
      bayWindowWidthMax: 3840,
      bayWindowHeightMax: 2160,
      previewSrc: "",
      disablePreview: true,
      robotWaysList: [
        {
          label: "default",
          value: "页面嵌入式聊天"
        },
        {
          label: "newPage",
          value: "新页面聊天（普通页面）"
        },
        {
          label: "digital",
          value: "新页面聊天（数智人页面）"
        }
      ],
      robotNameList: [
        // {
        //   robotId: "d769638fe7604ffab68be070250e4038",
        //   robotName: "小智机器人",
        //   robotCover: "//robot.chaoxing.com/static/robot-avatar/ljingtai.png",
        // },
        // {
        //   robotId: "3d52e31f978f4a4db38bc186a2be487d",
        //   robotName: "小智机器人1",
        //   robotCover: "//robot.chaoxing.com/sdk/sdkLogo.gif"
        // },
        // {
        //   robotId: "ca1c21e446d0413d8b8ece75a467b479",
        //   robotName: "小智机器人2",
        //   robotCover: "//robot.chaoxing.com/static/robot-avatar/ljingtai.png"
        // }
      ],
      layoutTypeList: [
        {
          label: "自由拖拽",
          value: "free"
        },{
          label: "纵向排列",
          value: "vertical"
        },{
          label: "横向排列",
          value: "horizon"
        },
      ],
      useSubHeadPage: false
    }
  },
  comments: {},
  components: {
    anchorExpandSetting,
    anchorBackSetting,
    anchorBtnSetting,
    anchorTipsSetting,
    CxPadding,
    positionSet,
    autoLayoutSetting,
    Swiper,
    SwiperSlide,
    elementPluginSetting,
    widthAndSizeAndZindex,
    pageLayoutStyle,
    rowColLayoutSetting,
    publicStyle
  },
  directives: {
    swiper: directive
  },
  created() {
    if (this.request_prefix === "appStage") {
      this.bayWindowWidthMax = 414
      this.bayWindowHeightMax = 414
    }
    this.getHeadLayoutTypes()
    const robotList = sessionStorage.getItem("robotList")
    this.robotNameList = robotList ? JSON.parse(robotList) : []
    this.checkSubHeadStatus()
  },
  watch: {
    inDocument(newVal, oldVal) {
      if (newVal === "header" || newVal === "footer") this.getHeadLayoutTypes()
    },
    ids: {
      handler(n, o) {
        this.staySetActive()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    isSubHeadPage() {
      return this.$store.state[this.request_prefix].page.isSubHeadPage
    },
    refHeadTitle() {
      return this.useSubHeadPage ?  "同步子页面头部样式" : "同步首页头部样式"
    },
    pageEnableFullScroll() {
      return this.$store.state[this.request_prefix].page.enableFullScroll
    },
    isNewAnchor() {
      return this.layoutOptions.isNewAnchor
    },
    // 锚点特殊样式 转盘
    isRollerAnchor() {
      return this.layoutOptions.isRollerAnchor || false
    },
    isWaterFall() {
      return this.$store.state[this.request_prefix].page.isWaterFall === "waterFall" ? true : false
    },
    isAdmin() {
      return this.$store.state.states.managerType === 1 ? true : false
    },
    isWaterFlow() {
      let layoutOptions = this.options.layout.rows[0]?.options
      return layoutOptions?.hasOwnProperty("waterFlow") ? layoutOptions.waterFlow : false
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    layoutOptions() {
      return this.options.options
    },
    inDocument() {
      return this.layoutOptions.inDocument
    },
    childSizeAuto: {
      get() {
        return this.layoutOptions.childSizeAuto || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "childSizeAuto", false)
      }
    },
    anchorBackConfig: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "anchorBackConfig", "anchorBackConfig", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorBackConfig", false)
      }
    },
    anchorExpandConfig: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "anchorExpandConfig", "anchorExpandConfig", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorExpandConfig", false)
      }
    },
    anchorBtnConfig: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "anchorBtnConfig", "anchorBtnConfig", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorBtnConfig", false)
      }
    },
    anchorTipsConfig: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "anchorTipsConfig", "anchorTipsConfig", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorTipsConfig", false)
      }
    },
    positionType: {
      get() {
        let positionType = this.layoutOptions.positionType
        if (positionType) {
          if (positionType === "fixed") {
            this.enableTeleport = true
          } else {
            this.enableTeleport = false
          }
          return positionType
        }
        positionType = this.isFixed ? "fixed" : "relative"
        if (positionType === "fixed") {
          this.enableTeleport = true
        } else {
          this.enableTeleport = false
        }
        this.$changeOptionsEV(positionType, "positionType", false, false, false, true)
        return positionType
      },
      set(newVal) {
        if (newVal !== "fixed") {
          this.enableTeleport = false
        } else {
          this.enableTeleport = true
        }
        this.$changeOptionsEV(newVal, "positionType", false)
        setTimeout(()=>{
          this.$eventBus.$emit(`update-pageLayout`)
        },50)
      }
    },
    positionSiteType: {
      get() {
        return this.layoutOptions.positionSiteType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "positionSiteType", false)
      }
    },
    pxOffset: {
      get() {
        return this.layoutOptions.pxOffset
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pxOffset", false)
      }
    },
    pLeft: {
      get() {
        return this.layoutOptions.pLeft
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pLeft", false)
      }
    },
    pTop: {
      get() {
        return this.layoutOptions.pTop
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pTop", false)
      }
    },
    pRight: {
      get() {
        return this.layoutOptions.pRight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pRight", false)
      }
    },
    pBottom: {
      get() {
        return this.layoutOptions.pBottom
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pBottom", false)
      }
    },
    translate: {
      get() {
        return this.layoutOptions.translate
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "translate", false)
      }
    },
    isFixed: {
      get() {
        return this.layoutOptions.isFixed || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isFixed", false)
      }
    },
    pageLayoutWidthType: {
      get() {
        // 1为充满 2为自定义 3为跟随版心
        if (this.isCustomWidth) {
          return "3"
        }
        if (this.isFullPage) {
          return "2"
        }
        return "1"
      },
      set(val) {
        switch (val) {
          case "1":
            this.$changeOptionsEV([false, false], ["isFullPage", "isCustomWidth"], false)
            break
          case "2":
            this.$changeOptionsEV([true, 100, "%", false], ["isFullPage", "width", "widthType", "isCustomWidth"], false)
            break
          case "3":
            this.$changeOptionsEV(
              [false, this.$store.state[this.request_prefix].page.pageWidth, "px", true],
              ["isFullPage", "width", "widthType", "isCustomWidth"],
              false
            )
            break
          default:
        }
      }
    },
    isCustomWidth: {
      get() {
        if (this.layoutOptions.hasOwnProperty("isCustomWidth")) {
          return this.layoutOptions.isCustomWidth
        }
        if (
          this.layoutOptions.positionType &&
          this.layoutOptions.positionType !== "relative" &&
          (this.layoutOptions.width || this.layoutOptions.anchorWidth)
        ) {
          return true
        }
        return false
      },
      set(val) {
        this.$changeOptionsEV(val, "isCustomWidth", false)
      }
    },
    customWidthType: {
      get() {
        return this.layoutOptions.widthType || "px"
      },
      set(val) {
        this.$changeOptionsEV(val, "widthType", false)
      }
    },
    customWidth: {
      get() {
        if (this.layoutOptions.inDocument === "anchor") {
          // 锚点   40是新加入锚点时候给的默认值
          return this.layoutOptions.anchorWidth || 40
        }
        return this.layoutOptions.width
      },
      set(val) {
        console.log("customWidth", val)
        let widthName = this.layoutOptions.inDocument === "anchor" ? "anchorWidth" : "width"
        this.$changeOptionsEV(val, widthName, false)
      }
    },
    isFullPage: {
      get() {
        return this.layoutOptions.isFullPage || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isFullPage", false)
      }
    },
    showScrollModelSetting() {
      return this.enableLayoutFullScroll && !this.globalEnableFullScroll
    },
    globalEnableFullScroll() {
      return this.$store.state[this.request_prefix].page.enableFullScroll
    },
    enableLayoutFullScroll: {
      get() {
        return this.layoutOptions.enableLayoutFullScroll || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "enableLayoutFullScroll", false)
      }
    },
    enableLeftNav:{
      get() {
        return this.layoutOptions.enableLeftNav || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "enableLeftNav", false)
        if(newVal){
          this.$changeOptionsEV([120,"px",true], ["width","widthType","isCustomWidth"], false)
        }else{
          this.$changeOptionsEV([false,false], ["isFullPage","isCustomWidth"], false)
          setTimeout(()=>{
            this.$eventBus.$emit(`update-pageLayout`)
          },50)

        }
      }
    },
    isHeaderOther:{
      get() {
        return this.layoutOptions.inDocument ==='headerOther'? true : false
      },
      set(newVal) {
        let val = newVal ? 'headerOther' :'none'
        this.$changeOptionsEV(val, "inDocument", false)
      }
    },
    layoutOverflowControl: {
      get() {
        return this.layoutOptions.layoutOverflowControl || "scroll"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "layoutOverflowControl", false)
      }
    },
    enableTeleport: {
      get() {
        return this.layoutOptions.enableTeleport ?? false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "enableTeleport", false)
      }
    },
    scrollModel: {
      get() {
        return this.$store.state[this.request_prefix].page.scrollModel || "smooth"
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "scrollModel", option_val: newVal })
      }
    },
    rectInContainerOptions() {
      const headLayout = this.pageLayoutList.find(layout => layout.options.inDocument === "header")
      if (headLayout) {
        //特殊处理头部画布
        return getAllRectInNewLayout([headLayout])
          .map(it => it.rects || [])
          .flat(1)
          .map(rect_id => {
            const rect = this.getAttrById(this.$store.state[this.request_prefix], { container_id: 0, rect_id })
            return {
              label: componentNames[rect?.shape],
              value: rect?.rect_id,
              rect
            }
          })
      } else return []
    },
    // primaryHeadContainerRect: {
    //   get() {
    //     //获取头部画布的默认组件
    //     const res = this.checkAndSetPrimaryVal(this.layoutOptions, "headComponentMap", "primaryHeadContainerRect", {
    //       ...basePrimaryHeadContainerRect
    //     })
    //     return res
    //   },
    //   set(val) {
    //     this.$changeOptionsEV(val, "headComponentMap", false)
    //   }
    // },
    rowLen: {
      get() {
        return this.options.layout.rows.length
      },
      set(newVal) {
        const before = deepCloneAndFreeze(this.pageLayoutList.find(pageLayout => pageLayout.id === this.options.id))
        let pageLayout = this.options.layout.rows
        let oldRowLen = pageLayout.length
        if (newVal > oldRowLen) {
          // 增加row
          let newId = 1
          let parentLayout = this.getAttrById(
            this.$store.state[this.request_prefix],
            { pageLayoutId: this.ids.pageLayoutId },
            "pageLayout"
          )
          parentLayout.layout.rows.forEach(item => {
            newId = item.id && item.id >= newId ? item.id + 1 : newId
          })
          for (let i = 0; i < newVal - oldRowLen; i++) {
            let layout = new mockData["primary" + this.request_prefix + "PageLayoutGenerator"](1)
            layout = layout.layout.rows[0]
            layout.id = newId
            newId++
            pageLayout.push(JSON.parse(JSON.stringify(layout)))
          }
        } else if (newVal < oldRowLen) {
          // 减少row
          pageLayout.splice(oldRowLen - newVal, oldRowLen - newVal)
        }
        this.$store.dispatch(this.request_prefix + "/changePageLayoutRow", {
          pageLayoutId: this.ids.pageLayoutId,
          pageLayout: pageLayout
        })
        this.$addHistory({
          type: "update",
          stateType: "updatePageLayout",
          payload: {
            container_id: 0,
            pageLayoutId: this.options.id
          },
          before,
          data: deepCloneAndFreeze(this.pageLayoutList.find(pageLayout => pageLayout.id === this.options.id))
        })
      }
    },
    opacity: {
      get() {
        return this.layoutOptions.opacity
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "opacity", false)
      }
    },
    marginBottom: {
      get() {
        return this.layoutOptions.marginBottom || 0
      },
      set(newVal) {
        if (!this.layoutOptions.direction) {
          this.$changeOptionsEV(["vertical", newVal], ["direction", "marginBottom"], false)
        } else {
          this.$changeOptionsEV(newVal, "marginBottom", false)
        }
      }
    },
    lineBorderWidth: {
      get() {
        return this.layoutOptions.lineBorderWidth || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineBorderWidth", false)
      }
    },
    background: {
      get() {
        let background = this.layoutOptions.bg
        if (background && Array.isArray(background) && background.length > 0) {
          if (background.length === 1 && background[0].type === "color" && !background[0].color)
            background[0].color = "rgba(255,255,255,0)"
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.layoutOptions.bgColor || "rgba(255,255,255,0)"
          }
        ]
        this.$changeOptionsEV(newBackground, "bg", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "bg", false)
      }
    },
    paddingTypeFlag: {
      get() {
        return this.layoutOptions.paddingTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.layoutOptions.padding[0]
      },
      set(newVal) {
        this.$changeOptionsEV([newVal, newVal, newVal, newVal], "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.layoutOptions.padding[0]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding.0", false)
      }
    },
    paddingRight: {
      get() {
        return this.layoutOptions.padding[1]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding.1", false)
      }
    },
    paddingBottom: {
      get() {
        return this.layoutOptions.padding[2]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding.2", false)
      }
    },
    paddingLeft: {
      get() {
        return this.layoutOptions.padding[3]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding.3", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.layoutOptions.boxShadowColor || "rgba(255,255,255,0)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.layoutOptions.boxShadowH || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.layoutOptions.boxShadowV || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.layoutOptions.boxShadowBlur || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.layoutOptions.boxShadowSpread || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    activePublicId: {
      get() {
        return this.layoutOptions.hasOwnProperty("activePublicId") ? this.layoutOptions.activePublicId : null
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activePublicId", false)
      }
    },
    isNotHomePage() {
      if (["listPage", "detailPage", "equalPage"].includes(this.pageType)) {
        return true
      }
      return false
    },
    showRefSetting() {
      // 平级和子级页面的头底才判断”是否展示排列外设置“
      if (
        !["listPage", "detailPage", "equalPage"].includes(this.pageType) ||
        !["header", "footer"].includes(this.inDocument)
      ) {
        return true
      }
      return this.layoutOptions.hasOwnProperty("isRefHome")
        ? !this.layoutOptions.isRefHome
        : this.pageType === "equalPage"
        ? true
        : false
    },
    useSubHead: {
      get() {
        return this.$store.state[this.request_prefix].page.useSubHead
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "useSubHead", option_val: newVal })
      }
    },
    isRefHome: {
      get() {
        // 平级页面为了兼容以前的老数据，所以默认不引用
        const defaultRef = this.pageType === "equalPage" ? false : true
        return this.checkAndSetPrimaryVal(this.layoutOptions, "isRefHome", "isRefHome", defaultRef)
      },
      set(newVal) {
        if (
          this.useSubHead !== undefined &&
          this.$store.state[this.request_prefix].page.subHeadPageId &&
          !newVal
        ) this.useSubHead = newVal
        // 如果取消了把同步首页导航的值也取消掉
        this.$nextTick(() => {
          if (newVal) {
            const name = this.inDocument === "header" ? "头部" : "底部"
            const pageName = this.inDocument === "header" && this.useSubHeadPage ? "子页面" : "首页"
            this.$confirm(`开启同步${pageName}${name}样式会丢失现有${name}样式，是否确认开启？`, "", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              showClose: false,
              dangerouslyUseHTMLString: "",
              iconClass: "bigScreen_confirm_icon el-icon-warning",
              cancelButtonClass: "bigScreen_confirm_cancel_button",
              confirmButtonClass: "bigScreen_confirm_button",
              customClass: "bigScreen_confirm custom_warning_dialog"
            })
              .then(() => {
                if (
                  this.useSubHead !== undefined &&
                  this.$store.state[this.request_prefix].page.subHeadPageId
                ) this.useSubHead = true
                if(typeof this.layoutOptions.isRefNav === "boolean" && !this.layoutOptions.isRefNav){
                  // 处理脏数据为false的情况
                  this.$changeOptionsEV([newVal,newVal], ["isRefHome","isRefNav"], false)
                }else{
                  this.$changeOptionsEV([newVal], ["isRefHome"], false)
                }
                // 新开启的同步首页样式，同时同步头部相关的样式，如变换头部
                this.$changeOptionsEV([newVal], ["isRefHomeOther"], false)
              })
              .catch(err => {})
          } else {
            // 取消同步时需要重新生成应用的appId避免在平级页面或者子页面修改应用数据影响首页
            // sessionStorage.setItem("regenerateAppId",true)
            // this.regenerateAppId()
            this.$changeOptionsEV([newVal], ["isRefHome"], false)
            // this.addSubPage()
          }
        })
      }
    },
    // isRefNav: {
    //   get() {
    //     return this.checkAndSetPrimaryVal(
    //       this.layoutOptions,
    //       "isRefNav",
    //       "isRefNav",
    //       this.layoutOptions.isRefNav ?? true
    //     )
    //   },
    //   set(newVal) {
    //     this.$nextTick(() => {
    //       this.$changeOptionsEV(newVal, "isRefNav", false)
    //     })
    //   }
    // },
    showSizeSet() {
      return this.layoutOptions.positionType === "fixed" ? true : false
    },
    bayWindow: {
      get() {
        return this.layoutOptions.enableBayWindow
      }
    },
    bayWidth: {
      get() {
        return this.layoutOptions.bayWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bayWidth", false)
      }
    },
    bayHeight: {
      get() {
        return this.layoutOptions.bayHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bayHeight", false)
        const pageLayoutList = this.pageLayoutList
        const pageLayoutIndex = pageLayoutList.findIndex(pageLayout => pageLayout.id === this.options.id)
        if (pageLayoutIndex > -1) {
          pageLayoutList[pageLayoutIndex].layout.rows[0].options.height = newVal
        }
      }
    },
    anchorWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "anchorWidth", "anchorWidth", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorWidth", false)
      }
    },
    anchorHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "anchorHeight", "anchorHeight", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorHeight", false)
      }
    },
    bayStartPosition: {
      get() {
        return this.layoutOptions.bayStartPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bayStartPosition", false)
      }
    },
    bayMoveSpeed: {
      get() {
        return this.layoutOptions.bayMoveSpeed
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bayMoveSpeed", false)
      }
    },
    bayManualClose: {
      get() {
        return this.layoutOptions.bayManualClose
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bayManualClose", false)
      }
    },
    getTranslate() {
      const index = this.moveSpeedList.findIndex(item => item.label === this.bayMoveSpeed)
      return {
        transform: `translateX(${50 * index}px)`
      }
    },
    pageLayoutList() {
      return this.$store.state[this.request_prefix].page.pageLayoutList
    },
    firstRowLayout() {
      let pageLayout = this.options.layout.rows[0]
      return pageLayout
    },
    smartServices: {
      get() {
        return this.layoutOptions.smartServices
      }
    },
    robotWays: {
      get() {
        return this.layoutOptions.robotWays || "default"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "robotWays", false)
      }
    },
    robotItem() {
      return this.robotNameList.find(item => item.robotId === this.robotId) || {}
    },
    robotCover: {
      get() {
        if (!this.layoutOptions.robotCover) {
          this.$changeOptionsEV(this.robotItem?.robotCover, "robotCover", false)
        }
        return this.robotItem?.buttonImg || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "robotCover", false)
      }
    },
    robotId: {
      get() {
        const robotId = this.robotNameList[0]?.robotId
        if (!this.layoutOptions.robotId) {
          this.$changeOptionsEV(robotId, "robotId", false)
        }
        return this.layoutOptions.robotId || robotId
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "robotId", false)
        this.$changeOptionsEV(this.robotItem?.buttonImg, "robotCover", false)
        this.$changeOptionsEV(this.robotItem?.encode, "robotEncode", false)
      }
    },
    anchorSettingStatus() {
      if (this.inDocument === "anchor") {
        return this.curNav === 0 ? 'main' : 'sub'
      } else {
        return 'none'
      }
    },
    borderTopLeftRadius: {
      get() {
        return Number(this.layoutOptions.borderTopLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return Number(this.layoutOptions.borderTopRightRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return Number(this.layoutOptions.borderBottomRightRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return Number(this.layoutOptions.borderBottomLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderRadius: {
      get() {
        return Number(this.layoutOptions.borderBottomLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderStyle: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "borderStyle", "borderStyle", "solid")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        // let defaultColor ={
        //   label: "颜色",
        //   type: "color",
        //   data: {
        //   angle: 0,
        //     stops: [
        //     ["rgba(255,255,255,0)", 0],
        //     ["rgba(255,255,255,0)", 1]
        //   ]
        // },
        //   color: "rgba(255,255,255,0)"
        // }
        // return this.checkAndSetPrimaryVal(this.layoutOptions, "borderColor", "borderColor", defaultColor)
        return this.checkAndSetPrimaryVal(this.layoutOptions, "borderColor", "borderColor", "#3D82F2")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        return this.layoutOptions.borderTypeFlag || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    showBorder: {
      get() {
        return this.layoutOptions.showBorder || false
      },
      set(newVal) {
        if(newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "borderWidth", "borderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.layoutOptions, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    zIndex:{
      get(){
        if(this.layoutOptions.hasOwnProperty("zIndex")){
          return this.layoutOptions.zIndex
        }
        // 通栏的定位规则
        const {
          positionType,
          enableBayWindow,
          inDocument
        } = this.layoutOptions
        let isShowAnchor = inDocument === "anchor"
        const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
        let ids = this.$store.state.states.activeID
        let pageLayoutIndex= ids.pageLayoutId?.toString().split("_")[0]
        let zIndex = isShowAnchor ? 10001 : pageLayoutList.length - pageLayoutIndex
        if (enableBayWindow) {
          zIndex = 9999
        } else if (positionType && (positionType === "fixed" || positionType === "absolute")) {
          zIndex = isShowAnchor ? 10001 : pageLayoutList.length + 1
          // 都有定位时 提高头部层级 避免下拉被遮挡
          switch (this.layoutOptions.inDocument) {
            case "header": //头部
              zIndex = pageLayoutList.length + 2
              break
            case "footer": //头部
              zIndex = 9999
              break
            default:
          }
        }
        return  zIndex
      },
      set(newVal){
        this.$changeOptionsEV(newVal, "zIndex", false)
      }
    },
    isSubHeadPage() {
      return this.$store.state[this.request_prefix].page.isSubHeadPage
    },
    showRowColLayout: {
      get() {
        return this.firstRowLayout?.options?.hasOwnProperty("showRowColLayout") ? this.firstRowLayout.options.showRowColLayout : false
      },
      set(newVal) {
        this.handleRowSet("showRowColLayout", newVal)
      }
    },
    autoLayoutType: {
      get() {
        if (this.showRowColLayout) {
          return this.firstRowLayout?.options?.rowColDirection || "vertical"
        } else {
          return "free"
        }
      },
      set(newVal) {
        if (newVal === "free") this.showRowColLayout = false
        else {
          this.showRowColLayout = true
          this.handleRowSet("rowColDirection", newVal)
        }
      }
    }
  },
  methods: {
    async checkSubHeadStatus() {
      const subHeadPageId = await getWebsiteSubHeadPageId(this.request_prefix === 'stage' ? 0 : 1)
      this.useSubHeadPage = subHeadPageId && this.pageType !== 'equalPage' ? true : false
    },
    changeNav(val, flag, subNavName) {
      this.curNav = val
      this.navName = subNavName
      this.$emit("update:statusOpened", flag)
      this.$emit("update:styleOpened", !flag)
      this.$emit("onHideHeader", flag)
      if (val === 0) {
        this.$eventBus.$emit('enableOpen', this.ids)
      }
    },
    // 判断是否是切换头部与关联头部样式后，是否保持开始设置tab
    staySetActive() {
      let changeHeaderType = sessionStorage.getItem("changeHeaderType")
      sessionStorage.removeItem("changeHeaderType")
      if (changeHeaderType) {
        document.getElementById("tab-seventh").click()
      }
    },
    moreClick() {
      // if (this.inDocument === "header" || this.inDocument === "relativeHeader") {
      //   this.curPageLayoutIndex = 0
      // } else if (this.inDocument === "footer") {
      //   this.curPageLayoutIndex = this.pageLayoutList.length - 1
      // } else if (this.inDocument === "anchor") {
      //   this.curPageLayoutIndex = 1
      // }
      this.curPageLayoutIndex = this.pageLayoutList.findIndex(item => item.options.inDocument === this.inDocument)
      this.showPageLayoutStyle = true
    },
    widthTypeHandleCommand(val) {
      if (this.customWidthType === val) {
        return
      }
      this.$changeOptionsEV([val, val === "%" ? 100 : 1200], ["widthType", "width"], false)
    },
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case 1:
          this.explainTextList = [
            {
              explainTitle: "未勾选宽度充满时：",
              explainTips: "通栏内的元素宽度等于内容区宽度。此时，设置通栏的左右边距无效。"
            },
            {
              explainTitle: "勾选宽度充满时：",
              explainTips: "通栏内的元素宽度将会占满整个容器。此时，设置通栏的左右的边距生效。"
            }
          ]
          this.explainVideoSrc = require("../../../assets/images/tipsVideoImg/full-page.mp4")
          break
        case 2:
          this.explainTextList = [
            {
              explainTitle: "",
              explainTips:
                "开启后，编辑页所有通栏将自动撑满全屏，网页将以通栏为单位，每次滑动鼠标，切换一整个通栏，实现整体网页的整屏切换效果"
            }
          ]
          this.explainVideoSrc = ""
          break
      }
    },
    getHeadLayoutTypes() {
      // let menuName = this.request_prefix === "appStage" ? "appMenu" : "menu"
      // 通栏分类 移动端不需要切换头底样式
      const layoutName = this.isWaterFall ? "新通栏样式" : "通栏样式"
      let typeLists = this.$store.state.menu?.menu?.otherTypes?.find(item => item.name.includes(layoutName))
      let typeName = ""
      if (this.inDocument === "header" || this.inDocument === "relativeHeader") {
        typeName = "头部通栏"
      } else if (this.inDocument === "footer") {
        typeName = "底部通栏"
      } else if (this.inDocument === "anchor") {
        typeName = "锚点"
      }
      let typeSubs = typeLists?.subs?.find(item => item.name === typeName)
      console.log("typeSubs", typeSubs)
      if (!typeSubs) return
      this.typeId = typeSubs.encId
      this.getStyles(this.typeId)
    },
    getStyles(styleId) {
      if (!!!styleId) {
        return
      }
      this.$API
        .queryComponentList({
          typeId: styleId,
          p2: 20,
          lsc: true
        })
        .then(res => {
          this.styleDatas = res.data?.data?.PageInfo?.list
          this.swiperLen = Math.ceil(this.styleDatas.length / 6)
        })
    },
    selectStyle(item) {
      this.$confirm("切换通栏样式后模板数据会覆盖现有数据， 是否确认切换？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        showClose: false,
        dangerouslyUseHTMLString: "",
        iconClass: "bigScreen_confirm_icon el-icon-warning",
        cancelButtonClass: "bigScreen_confirm_cancel_button",
        confirmButtonClass: "bigScreen_confirm_button",
        customClass: "bigScreen_confirm custom_warning_dialog"
      })
        .then(() => {
          //执行同步操作
          this.changePageLayoutStyle(item)
        })
        .catch(err => {})
    },
    async changePageLayoutStyle(item) {
      if (this.activePublicId === item.publicId) return
      // let data = await this.$API.queryComponentContent({
      //   encId: item.encId
      // })
      const { pageId } = this.$store.state.states.getDataPageIds
      let data = await this.$API.queryComponentContentClone({
        encId: item.encId,
        p: pageId
      })
      // 改变当前布局显示内容
      await this.changeHeadFootLayout(data)
      this.activePublicId = item.publicId
    },
    async changeHeadFootLayout(item) {
      this.hasHeadComponentNav = false
      let pageLayoutList = this.pageLayoutList
      let index = pageLayoutList.findIndex(item => item.options.inDocument === this.inDocument)
      if (index === -1) return
      let content = JSON.parse(item.data.data.content)
      let rects = content.rects
      rects.forEach(item => {
        //还原被encryption方法加密过json字符串
        item.c = decrypt(item.c, data_dictionary_map)
        //将json中的rem转为px
        reverseBuildModel(item.c)
      })
      let newLayout = JSON.parse(JSON.stringify(content.pageLayout))
      newLayout.id = pageLayoutList[index].id
      newLayout.options.inDocument = this.inDocument
      // 子页面切换样式继承isRefHome属性
      newLayout.options.isRefHome = pageLayoutList[index]?.options?.isRefHome
      // newLayout.id = this.getNewLayoutId()
      // 保留通栏的切换头部的关系
      if (pageLayoutList[index]?.options && this.inDocument === "header") {
        let oldOptions = pageLayoutList[index]?.options
        newLayout.options.openHeaderRelation = oldOptions.openHeaderRelation
        newLayout.options.syncHeaderNav = oldOptions.hasOwnProperty("syncHeaderNav") ? oldOptions.syncHeaderNav : true
        newLayout.options.relativeHeaderRule = oldOptions.hasOwnProperty("relativeHeaderRule")
          ? oldOptions.relativeHeaderRule
          : "firstScreen"
        newLayout.options.relativeHeaderFixedTop = oldOptions.relativeHeaderFixedTop || 0
        newLayout.options.animateOfIn = oldOptions.animateOfIn
        newLayout.options.animateOfOut = oldOptions.animateOfOut
      }
      this.getHeaderNavAppid(pageLayoutList)
      this.newLayout = newLayout
      newLayout = await this.handleRect(this.newLayout, rects, newLayout)
      pageLayoutList.splice(index, 1, this.newLayout)
      this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: pageLayoutList })
      // 修改锚点组件
      if (this.$store.state[this.request_prefix].page.isShowAnchor) {
        this.changeAnchorBtn(pageLayoutList, pageLayoutList[index])
      }
    },
    // 获取头部导航的appid
    getHeaderNavAppid() {
      if (this.layoutOptions.inDocument !== "header" && this.layoutOptions.inDocument !== "relativeHeader") {
        return
      }
      let headerPageLayout = this.layoutOptions
      // 如果已经勾选了内置导航组件则用指定的导航组件，否则使用第一个导航组件
      if (
        headerPageLayout &&
        headerPageLayout.headComponentMap &&
        (typeof headerPageLayout.headComponentMap.nav === "number" || typeof headerPageLayout.headComponentMap.nav === "string")
      ) {
        const rects = this.$store.state[this.request_prefix].page.children[0].children
        const path = findRectPath(rects, "nav", headerPageLayout.headComponentMap.nav)
        let nav = this.getAttrById.call(
          this,
          this.$store.state[this.request_prefix],
          path,
          "rect"
        )
        if (nav?.options) {
          this.headerNavAppId = nav.options.appId
          if (nav.options.hasOwnProperty("useOwnSubPages")) {
            this.headerNavAppId = nav.options.useOwnSubPages
          }
        }
      } else {
        let headerNav = []
        this.getHeaderNav(headerPageLayout, headerNav)
        if (headerNav.length > 0) {
          this.headerNavAppId = headerNav[0].options.appId
          if (headerNav[0].options.hasOwnProperty("useOwnSubPages")) {
            this.headerNavAppId = headerNav[0].options.useOwnSubPages
          }
        }
      }
    },
    // 获取通栏中的导航组件
    getHeaderNav(pageLayout, relativeHeaderNav) {
      if (pageLayout.layout.rows?.length > 0) {
        pageLayout.layout.rows.forEach(layout => {
          this.getHeaderNav(layout, relativeHeaderNav)
        })
      } else if (pageLayout.layout.cols?.length) {
        pageLayout.layout.cols.forEach(layout => {
          this.getHeaderNav(layout, relativeHeaderNav)
        })
      } else {
        if (pageLayout.rectIds.length > 0) {
          for (let i = 0; i < pageLayout.rectIds.length; i++) {
            let rectAttr = this.getAttrById(
              this.$store.state[this.request_prefix],
              {
                container_id: this.ids.container_id,
                rect_id: pageLayout.rectIds[i]
              },
              "rect"
            )
            if (rectAttr && rectAttr.shape.toLowerCase().includes("nav")) {
              relativeHeaderNav.push(rectAttr)
            }
          }
        }
      }
    },
    async changeAnchorBtn(pageLayoutList, anchorPageLayout) {
      // 排除用fixed定位的通栏、被隐藏的通栏、锚点通栏
      let pageListLen = 0
      pageLayoutList.forEach(pageLayout => {
        let type = pageLayout.options.inDocument
        if (type !== "anchor" && pageLayout.options.position !== "fixed" && pageLayout.options.isShow) {
          pageListLen++
        }
      })
      if (anchorPageLayout.options.inDocument === "anchor") {
        let rectIds = anchorPageLayout?.layout?.rows[0]?.rectIds
        let rectIdsLen = anchorPageLayout?.layout?.rows[0]?.rectIds?.length
        let elementList = []
        if (rectIds) {
          rectIds.forEach(item => {
            elementList.push(
              this.$store.state[this.request_prefix].page.children[0].children.find(rect => rect.rect_id === item)
            )
          })
        }
        console.log("pageListLen :>>", pageListLen, rectIdsLen)
        if (pageListLen < rectIdsLen - 2) {
          // 减少锚点个数
          let len = rectIdsLen - 2 - pageListLen
          rectIds.splice(pageListLen, len)
        } else if (pageListLen > rectIdsLen - 2) {
          // 添加锚点个数
          let index = rectIdsLen > 2 ? rectIdsLen - 2 : 0
          let len = pageListLen - (rectIdsLen - 2)
          let param = {
            active: false,
            draggable: false,
            hoverZIndex: 1,
            parentLim: true,
            resizable: true,
            shape: "cxButton",
            options: JSON.parse(JSON.stringify(elementList[0]?.options))
          }
          for (var j = 0; j < len; j++) {
            if (Number(index + 1 + j) < 10) {
              param.options.content = "0" + Number(index + 1 + j)
            } else {
              param.options.content = Number(index + 1 + j)
            }
            await this.addNewRect(
              {
                rectAttr: param,
                cellRect: rectIds,
                index: Number(index + j),
                isClone: false
              },
              "",
              "addBtn"
            )
          }
        }
      }
    },
    async handleRect(newLayout, rects, originLayout) {
      newLayout.layout.rows?.forEach(row => {
        return this.handleRect(row, rects, originLayout)
      })
      newLayout.layout.cols?.forEach(col => {
        return this.handleRect(col, rects, originLayout)
      })
      for (let j = 0; j < newLayout?.rectIds?.length; j++) {
        const item = newLayout.rectIds[j]
        for (let i = 0; i < rects.length; i++) {
          if (rects[i].c.rect_id === item) {
            // 切换样式，判断该组件是否是 之前指定的内置组件
            let isHeadComponent = false
            let headComponentType
            for (let key in originLayout.options.headComponentMap) {
              if (originLayout.options.headComponentMap[key] === item) {
                isHeadComponent = true
                headComponentType = key
                this.hasHeadComponentNav = key === "nav" ? true : false
                break
              }
            }
            await this.addNewRect({
              rectAttr: rects[i].c,
              cellRect: newLayout.rectIds,
              index: j,
              isClone: false,
              isHeadComponent: isHeadComponent,
              headComponentType: headComponentType,
              originLayout: originLayout
            })
          }
        }
      }
      return newLayout
    },
    // 新加入rect
    async addNewRect(param, e, type) {
      let rectAttr = JSON.parse(JSON.stringify(param.rectAttr))
      // 如果当前数据中存在appId判断当前组件是否是系统保存好的样式
      const isNavComponent = rectAttr.shape.toLowerCase().includes("nav")
      // 目前部分样式的headComponentMap 和组件对应不上，
      // 暂时只判断了是导航组件,判断是指定的导航组件，如果不是则判断是否是第一个导航组件

      // 判断是不是勾选的关联 头部导航
      let isHeaderNav = param.isHeadComponent && param.headComponentType === "nav"
      if (!isHeaderNav && rectAttr.shape === "cxNavMenu" && !this.hasHeadComponentNav) {
        isHeaderNav = true
        this.hasHeadComponentNav = true
      }
      if (isHeaderNav) {
        rectAttr.options.appId = this.headerNavAppId
        if (rectAttr.options.myFetchParam && rectAttr.options.myFetchParam.appId) {
          rectAttr.options.myFetchParam.appId = this.headerNavAppId
        }
      }
      if (!isHeaderNav && (rectAttr.options.myFetchParam?.appId || rectAttr.options.appId)) {
        //更新appid
        const appId = rectAttr.options.appId ? rectAttr.options.appId : rectAttr.options.myFetchParam?.appId
        // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
        const isSearchComponent = rectAttr.options.pluginName?.includes("searchComponentPlugin")
        // const res = await this.$styleToSaveModule(
        //   "31CB73E03E24BBFF",
        //   "临时",
        //   appId,
        //   param.isClone,
        //   isSearchComponent,
        //   isNavComponent
        // )
        if (!!appId) {
          // 没有myfetchparam的组件 比如搜索组件 更新appId
          rectAttr.options.appId = appId
          //如果拖入画布的组件有，myfetchparam，证明是自由布局或者轮播
          //则pageId,wfwfid,websiteId,更新为当前页面的值，防止老组件id不兼容
          // if (rectAttr?.options?.myFetchParam) {
          //   const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
          //   rectAttr.options.appId = res.appId
          //   rectAttr.options.moduleId = res.moduleId
          //   rectAttr.options.myFetchParam.pageId = pageId
          //   rectAttr.options.myFetchParam.wfwfid = wfwfid
          //   rectAttr.options.myFetchParam.websiteId = websiteId
          //   rectAttr.options.myFetchParam.appId = res.appId
          // }

          const uuidRectId = uuid.v1()
          if (this.isSubHeadPage) {
            rectAttr.rect_id = uuidRectId
            rectAttr.options.inSubHead = true
          }
          const params = {
            containerID: this.ids.container_id,
            data: rectAttr
          }
          this.$store.dispatch(this.request_prefix + "/addElement", params).then(res => {})
          let newIndex = param.index
          const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
            container_id: this.ids.container_id
          }).children
          let _rect_id = -1
          if (allRects.length > 0) {
            _rect_id = smartMathMax(
              ...allRects.map(function (o) {
                return o.rect_id
              })
            )
          }
          let rect_id = _rect_id
          if (this.isSubHeadPage) {
            rect_id = uuidRectId
          }
          if (param.isHeadComponent) {
            // rect_id 改变后，改变对应的headComponentMap值
            param.originLayout.options.headComponentMap[param.headComponentType] = rect_id
          }
          if (type === "addBtn" && typeof newIndex !== "undefined") {
            // 添加锚点按钮逻辑
            param.cellRect.splice(newIndex, 0, rect_id)
          } else {
            if (typeof newIndex !== "undefined") {
              param.cellRect.splice(newIndex, 1, rect_id)
            } else {
              param.cellRect.push(rect_id)
            }
          }
        }
      } else {
        const uuidRectId = uuid.v1()
        if (this.isSubHeadPage) {
          rectAttr.rect_id = uuidRectId
          rectAttr.options.inSubHead = true
        }
        const params = {
          containerID: this.ids.container_id,
          data: rectAttr
        }
        this.$store.dispatch(this.request_prefix + "/addElement", params)
        let newIndex = param.index
        const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          container_id: this.ids.container_id
        }).children
        let _rect_id = -1
        if (allRects.length > 0) {
          _rect_id = smartMathMax(
            ...allRects.map(function (o) {
              return o.rect_id
            })
          )
        }
        let rect_id = _rect_id
        if (param.isHeadComponent) {
          // rect_id 改变后，改变对应的headComponentMap值
          param.originLayout.options.headComponentMap[param.headComponentType] = rect_id
        }
        if (!param.isHeadComponent && isHeaderNav) {
          // 没有指定头部导航组件的时候，默认选第一个
          param.originLayout.options.headComponentMap.nav = rect_id
        }
        if (this.isSubHeadPage) {
          rect_id = uuidRectId
        }
        if (type === "addBtn" && typeof newIndex !== "undefined") {
          // 添加锚点按钮逻辑
          param.cellRect.splice(newIndex, 0, rect_id)
        } else {
          if (typeof newIndex !== "undefined") {
            param.cellRect.splice(newIndex, 1, rect_id)
          } else {
            param.cellRect.push(rect_id)
          }
        }
      }
    },
    delComponent(param) {
      const self = this
      if (param.encId) {
        this.$confirm("确认删除吗？", "", {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
          iconClass: "bigScreen_confirm_icon el-icon-warning",
          cancelButtonClass: "bigScreen_confirm_cancel_button",
          confirmButtonClass: "bigScreen_confirm_button",
          customClass: "bigScreen_confirm custom_warning_dialog"
        })
          .then(() => {
            instance
              .post(`v2/${param.encId}/remove`)
              .then(() => {
                this.getStyles(this.typeId)
              })
              .catch(err => {})
          })
          .catch(() => {})
      }
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    selectVisibleChange(name, visible) {
      if (visible) {
        this.watchSelectOpt(name)
      } else {
        this.delWatchSelectOpt(name)
      }
    },
    watchSelectOpt(name) {
      this.$nextTick(() => {
        const selects = document.getElementsByClassName(name)
        Array.prototype.find
          .call(selects, el => el.style.display !== "none")
          .addEventListener("mouseover", this.handleSelectMouseover, true)
      })
    },
    delWatchSelectOpt(name) {
      const selects = document.getElementsByClassName(name)
      Array.prototype.find
        .call(selects, el => el.style.display !== "none")
        .removeEventListener("mouseover", this.handleSelectMouseover, true)
      if (this.activeRectId !== null) {
        this.$store.commit(this.request_prefix + "/DISABLE_ACTIVE", {
          container_id: this.ids.container_id,
          rect_id: this.activeRectId
        })
        this.activeRectId = null
      }
    },
    handleSelectMouseover(e) {
      if (e.target.classList.contains("el-select-dropdown__item")) {
        const rect_id = Number(e.target.dataset.value)
        this.activeRectId = rect_id
        this.$store.dispatch(this.request_prefix + "/setActive", {
          container_id: this.ids.container_id,
          rect_id
        })
      }
    },
    changeContainerPrimaryRect(type, name, rect_id) {
      this.$changeOptionsEV(rect_id, `${type}.${name}`, false)
    },
    filterRect(rects, k) {
      let res = null
      switch (k) {
        case "nav":
          res = rects.filter(currRect => {
            const { rect } = currRect
            return rect?.shape === "cxNavMenu"
          })
          break
        case "logo":
          res = rects.filter(currRect => {
            const { rect } = currRect
            return rect?.shape === "imageComponent"
          })
          break
        case "login":
          res = rects.filter(currRect => {
            const { rect } = currRect
            return (
              rect?.shape === "emptyLayoutComponent" &&
              rect?.options.pluginName &&
              rect?.options.pluginName.find(name => name === "loginLayoutComponent")
            )
          })
          break

        default:
          break
      }
      return res
    },
    changeRowLen(flag) {
      if (this.rowLen === 1 && flag === 0) {
        return
      }
      if (this.rowLen === 10 && flag === 1) {
        return
      }
      this.rowLen = flag === 0 ? this.rowLen - 1 : this.rowLen + 1
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    handleSet(key, val) {
      this.$changeOptionsEV(val, key, false)
    },
    handleRowSet(key, val) {
      this.$changeOptionsEV(val, key, false, null, {
        container_id: this.ids.container_id,
        pageLayoutId: this.ids.pageLayoutId + "_" + this.firstRowLayout.id
      })
    },
    swiperPrev() {
      this.$refs.mySwiper.$swiper.slidePrev()
    },
    swiperNext() {
      this.$refs.mySwiper.$swiper.slideNext()
    },
    changeMoveSpeed(val) {
      this.bayMoveSpeed = val
    },
    regenerateAppId() {
      // 重新生成通栏里面所有含有appId组件的appId
      const { homePageId } = this.$store.state.states.getDataPageIds
      const headLayout = this.pageLayoutList.find(layout => layout.options.inDocument === "header")
      let allRectId = getAllRectInNewLayout([headLayout])
          .map(it => it.rects || [])
          .flat(1)
      allRectId.map(rect_id => {
        const rect = this.getAttrById(this.$store.state[this.request_prefix], { container_id: 0, rect_id })
        if (rect.options.appId) {
          this.$changeOptionsEV(true, "useOwnSubPages", false, null, { container_id: 0, rect_id: rect.rect_id })
        }
        handleChildAppid.call(this, rect, this.ids.container_id, undefined, true, homePageId)
      })
    },
    async addSubPage() {
      // 第一次点击同步首页头部导航appId会变成新的，保存会把以前对应的子页面关系清除，所以取消勾选需要创新创建子页面
      let allRectId = getAllRectInNewLayout([this.options])
      if (!allRectId) return
      let navRectAttr = ""
      allRectId.forEach(item => {
        if (item.rects[0]) {
          const rectAttr = this.getAttrById.call(
            this,
            this.$store.state[this.request_prefix],
            {
              container_id: this.ids.container_id,
              rectId: item.rects[0]
            },
            "rect"
          )
          if (rectAttr.shape === "cxNavMenu") {
            // 头部导航
            navRectAttr = rectAttr
          }
        }
      })
      if (!navRectAttr) return
      let appId = navRectAttr.options?.appId
      const index = this.$store.state[this.request_prefix].page?.subPages?.findIndex(item => item.appId === appId)
      // 判断是否有子页面关系 没有重新创建
      if (typeof index === "undefined" || index === -1) {
        await addSubPageMapping.call(this, appId, false, true)
      }
    },
    setMouseEnter(ev) {
      this.disablePreview = false
      const img = ev.target.children[0],
        width = img.naturalWidth,
        height = img.naturalHeight,
        previewPopover = document.getElementsByClassName("previewPopover")[0],
        baseSize = 616
      this.previewSrc = img.src
      if (width && height) {
        if (width > height) {
          previewPopover.style.width = `${baseSize}px`
          previewPopover.style.height = `${parseInt((height / width) * baseSize)}px`
        } else {
          previewPopover.style.height = `${baseSize}px`
          previewPopover.style.width = `${parseInt((width / height) * baseSize)}px`
        }
      } else {
        previewPopover.style.width = `${baseSize}px`
        previewPopover.style.height = `${baseSize}px`
      }
      previewPopover.style.padding = "8px"
      previewPopover.style.borderRadius = 0
      previewPopover.style.boxShadow = "0px 6px 24px 0px rgba(31, 35, 41, 0.1)"
      previewPopover.style.border = "1px solid rgba(233, 233, 233, 1)"
      this.$refs.previewPopover.updatePopper()
    },
    setMouseOut(ev) {
      if (
        ev.toElement &&
        ev.toElement.className &&
        !ev.toElement.className.includes("product-img-box") &&
        !ev.toElement.parentElement.className.includes("product-img-box")
      ) {
        this.disablePreview = true
      }
    }
  }
})
</script>

<style scoped lang="scss">
.navBox {
  height: 32px;
  padding: 4px 4px 4px 12px;
  border-radius: 4px;
  background: var(--inputBg);
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:hover {
    background: var(--inputNuberHoverThemeBgColor);
  }
  .navTitle {
    font-size: 13px;
    font-weight: 600;
    color: var(--textColor);
  }
  .navLabel{
    color: var(--thirdTextColor);
    display: flex;
  }
  .navIcon {
    font-size: 20px;
  }
  &:hover{
    // background-color: rgba(233, 233, 233, 1);
    cursor: pointer;
  }
}
.navBackBox {
  height: 38px;
  padding-left: 12px;
  display: flex;
  gap: 4px;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  .navBackIcon {
    font-size: 24px;
  }
  .navBackTitle {
    font-size: 14px;
    font-weight: 600;
    color: var(--textColor);
  }
}
p {
  margin-bottom: 0;
}

.arrange-sets {
  justify-content: space-between;
}

.row-set {
  flex: 1;

  input {
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-right: 16px;
  }

  .btn-wrapper {
    flex: 1;
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 6px 0;
    font-size: 0;

    .num-btn {
      display: inline-block;
      width: 50%;
      text-align: center;
      line-height: 20px;
      font-size: 13px;
      cursor: pointer;
      color: var(--subTextColor);

      &:not(:last-child) {
        border-right: 1px solid var(--sliderBackGround);
      }

      &:not(.disabled):hover {
        color: var(--themeColor);
      }

      &.disabled {
        color: var(--borderColorSeven);
        cursor: not-allowed;
      }
    }
  }
}

.lineHeight32 {
  display: inline-block;
  line-height: 32px;
}

::v-deep.content-group-default .el-input input {
  background: var(--inputBackGround);
  color: var(--textColor);
}

::v-deep input {
  color: var(--textColor);
}

.mt4 {
  margin-top: 4px;
}

.content {
  position: relative;
}

.types-options-style {
  padding: 12px 16px 0 16px;

  &:hover {
    .swiper-button {
      display: block;
    }
  }
}

.pd12-16 {
  padding: 12px 16px;
}

.types-list {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  gap: 12px;
  .types-list-li {
    // position: relative;
    // display: inline-block;
    // margin-right: 8px;
    // margin-bottom: 16px;
    // width: calc(((100% - 16px) / 3));
    width: 108px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 4px;
    cursor: pointer;

    &:nth-child(3n) {
      margin-right: 0;
    }

    .img-box {
      position: relative;
      width: 100%;
      height: 85px;
      border: 1px solid var(--elCollapseItemBorderColor);
      background: var(--editBgColor);
      box-sizing: border-box;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    p {
      margin-bottom: 0;
      color: var(--textColor);
      line-height: 20px;
      // margin-top: 8px;
      text-align: center;
    }

    .delete-icon {
      position: absolute;
      display: none;
      bottom: 2px;
      right: 2px;
      border-radius: 2px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background-color: var(--iconHoverBgColor);
      color: var(--iconColor);
      font-size: 12px;
    }

    .icon-checked {
      position: absolute;
      right: 0;
      top: 0;
      width: 24px;
      height: 24px;
      background-image: url(../../../assets/images/icon-checked.png);
      background-size: 100% 100%;
      display: none;
    }

    &:hover {
      .delete-icon {
        display: block;
      }
    }

    &.active {
      .img-box {
        border: 2px solid var(--themeColor);

        .icon-checked {
          display: block;
        }
      }
    }
  }
}

.swiper-button {
  width: 14px;
  height: 46px;
  line-height: 45px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 0px 2px 2px 0px;
  color: var(--subTextColor);
  margin-top: -48px;
  display: none;
}

.swiper-button::after {
  font-size: 12px;
}

.swiper-button-prev {
  left: -14px;
}

.swiper-button-next {
  right: -14px;
}

.margin-top-16 {
  margin-top: 16px;
}

.move-speed-btn {
  display: inline-flex;
  position: relative;
  width: 156px;
  background: var(--inputBackGround);
  height: 30px;
  padding: 3px;
  border-radius: 4px;
  box-sizing: border-box;
  user-select: none;

  span {
    width: 50px;
    text-align: center;
    line-height: 24px;
    cursor: pointer;
    color: var(--thirdTextColor);
    position: relative;

    &::after {
      position: absolute;
      content: "";
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 14px;
      background: var(--borderColorSeven);
    }

    &.btn-active::after,
    &.select::after,
    &.select + span::after,
    &:nth-child(2)::after {
      display: none;
    }
  }

  .btn-active {
    height: 24px;
    position: absolute;
    top: 3px;
    background: var(--leftMenuBgColor);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .pd2 {
    z-index: 1;
  }

  .select {
    color: var(--themeColor) !important;
  }
}

.custom-label {
  display: inline-block;
  vertical-align: middle;
}

.custom-width-inp {
  vertical-align: middle;
  overflow: hidden;
}
.more-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--thirdTextColor);
  font-weight: 400;
}
.more-btn:hover {
  color: var(--themeColor);
}
.robot-box {
  background: var(--cardBgColor);
  border: 1px solid var(--borderColorFour);
  border-radius: 4px;
  padding: 8px;
  .img-box {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    border: 1px solid var(--borderColorFour);
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .text-box {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 80px;
    margin-left: 8px;
    width: calc(100% - 88px);
    .text-title {
      font-size: 13px;
      color: var(--textColor);
    }
    .text-id {
      font-size: 12px;
      color: var(--thirdTextColor);
      margin-top: 8px;
    }
  }
}
</style>
